<template>
  <div class="w-100 bg-primary py-5 px-3 d-flex justify-content-center welcome-page-wrapper">
    <div class="d-flex flex-column align-items-center form-wrapper">
      <div class="p-4 logo-container w-100 d-flex flex-column align-items-center">
        <img src="@/../public/img/brand/logo_white.svg" alt="Wallkit" height="60" class="mb-1">
      </div>
      <h3 class="font-weight-light mb-4 text-center mt-3">{{$t('onboarding.register_new_partner')}}</h3>
      <b-button
          variant="link"
          class="text-white align-self-start px-0"
          to="/login"
      >
        {{$t('login.back_to_sign_in')}}
      </b-button>
      <PublicPartnersRegistrationView :inputs="inputs.partner.items"/>
    </div>
  </div>
</template>

<script>
import inputs from "./partnerRegistrationFields"
import PublicPartnersRegistrationView from "./PublicPartnersRegistrationView";
export default {
  name: "PublicPartnersRegistration",
  middleware: 'no-auth',
  components: {PublicPartnersRegistrationView},
  data () {
    return {
      inputs: inputs
    }
  }
}
</script>
